import type { ComponentProps } from 'react';
import React from 'react';
import NextLink from 'next/link';

import { sanitizeURL } from '@/utils/domain/route';
/* eslint-disable no-restricted-imports */
import { Link } from '@chakra-ui/react';
import { isEmpty } from 'es-toolkit/compat';

export type SafeLinkProps = {
  href: string;
} & ComponentProps<typeof Link> &
  ComponentProps<typeof NextLink>;

/**
 * To navigate to an internal or external route, use the `SafeLink` component.
 * There is an issue that navigating performance is too low, when we navigate to wordpress route with next/link without origin.
 * @param param0
 * @returns
 */
export const SafeLink = ({ href, children, ...props }: SafeLinkProps) => {
  const { url, isNextRoute } = sanitizeURL(href);

  if (isNextRoute) {
    return (
      <Link asChild {...props} href={url}>
        <NextLink href={url} {...props}>
          {children}
        </NextLink>
      </Link>
    );
  }

  return (
    <Link {...(isEmpty(props) && { unstyled: true })} {...props} href={url}>
      {children}
    </Link>
  );
};
